import {TableCell, TableHead, TableRow} from "@mui/material";
import {LoadingSkeleton} from "./LoadingSkeleton";

export const LoadingRow = ({items = 4}: {items?: number}) => {

    const itemsMap = new Array(items).fill(undefined)
    const loadingComponent = (
        <LoadingSkeleton height={15} width={45} />
    );

    const tableCell = (ind: number) => (
        <TableCell component="th" scope="row" align="left" key={ind}>
            {loadingComponent}
        </TableCell>
    )

    return (
        <TableHead>
            <TableRow
                sx={{ '& > *': {paddingTop: '9px !important', paddingBottom: '9px !important'}}}
            >
                {itemsMap.map((item: typeof tableCell, ind: number) => {
                    return tableCell(ind);
                })}
            </TableRow>
        </TableHead>
    )
}